import { render, staticRenderFns } from "./FileDeleteModal.vue?vue&type=template&id=46ab8cb2&"
import script from "./FileDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./FileDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports